import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingChangeToManager } from 'services/setting'
import posthog from 'posthog-js'

const SUCCESS_TOAST: { [role: string]: string } = {
    mgr: 'کاربر با موفقیت مدیر شد',
    nrm: 'کاربر با موفقیت عضو عادی شد',
    bnk: 'کاربر با موفقیت بانی شد',
}

const FAILED_ACTION: { [role: string]: string } = {
    mgr: 'promote_to_manager',
    nrm: 'demote_to_normal',
    bnk: 'assign_banker',
}

/**
 * Shared by the «مدیر», «عضو» and «بانی» role modals. poolship/update/ is a
 * legacy view: a refusal (not a manager, bad role…) still comes back as HTTP
 * 200 with a non-2050 `code`, so that is checked here — before, a refused
 * change still toasted success.
 */
export default function useSetManager(refetch: () => void) {
    const { mutate } = useMutation({
        mutationFn: async (payload: IChangeManagerSettingPayload) => {
            const data = await settingChangeToManager(payload)
            if (typeof data?.code === 'number' && data.code !== 2050) {
                throw Object.assign(new Error('poolship update refused'), {
                    code: data.code,
                })
            }
            return data
        },
        onSuccess: (data, variables: IChangeManagerSettingPayload) => {
            const props = {
                fund_id: variables?.moneyPool,
                poolship_id: variables?.poolShip,
            }
            if (variables?.role === 'bnk') {
                posthog.capture('banker_role_assigned', props)
            } else {
                if (variables?.fromRole === 'bnk') {
                    posthog.capture('banker_role_removed', props)
                }
                posthog.capture(
                    variables?.role === 'nrm'
                        ? 'member_demoted_to_normal'
                        : 'member_promoted_to_manager',
                    props
                )
            }
            refetch()
            toast.success(
                SUCCESS_TOAST[variables?.role] ?? 'تغییرات با موفقیت انجام شد'
            )
        },
        onError: (error: any, variables: IChangeManagerSettingPayload) => {
            posthog.capture('member_action_failed', {
                action: FAILED_ACTION[variables?.role] ?? 'change_role',
                fund_id: variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
                code: error?.code,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
